@use '../../scss/utility';

$transition-duration: 300ms;

:host {
  --focus-color: var(--wb-blue-45);

  display: block;
  position: relative;
}

.button {
  @include utility.wb-text('l');
  border: utility.wb-pixel-to-rem(1px) solid var(--wb-grey-70);
  background-color: var(--wb-grey-95);
  display: flex;
  height: utility.wb-pixel-to-rem(56px);
  align-items: center;
  padding-block: 0;
  padding-inline: utility.wb-pixel-to-rem(8px) utility.wb-pixel-to-rem(16px);
  outline: none;
  color: var(--wb-black);

  &:focus {
    border-color: var(--focus-color) !important;
  }
}

.label {
  font-size: utility.wb-pixel-to-rem(16px);
  margin-inline-start: utility.wb-pixel-to-rem(8px);
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: calc(100% - 40px);
  white-space: nowrap;
}

:host([disabled]) button:hover {
  background-color: var(--wb-white);
}

.close {
  width: 0;
  opacity: 0;
  background-color: transparent;
  height: utility.wb-pixel-to-rem(24px);
  border-radius: var(--wb-radius-full);
  display: flex;
  justify-content: center;
  align-items: center;
  transition:
    width $transition-duration var(--wb-move),
    opacity 200ms 100ms var(--wb-fade);
  padding: 0;
  border: none;
  cursor: pointer;

  @media (prefers-reduced-motion) {
    transition: width 0s;
  }

  &:hover {
    background-color: var(--wb-grey-90);
  }

  &.is-visible {
    width: utility.wb-pixel-to-rem(24px);
    flex-shrink: 0;
    opacity: 1;
  }
}

.close-icon {
  --size: #{utility.wb-pixel-to-rem(16px)};
}

.caret-icon {
  --size: #{utility.wb-pixel-to-rem(16px)};
  margin-inline-start: auto;
  flex-shrink: 0;
  color: var(--wb-black);
}

.counter {
  margin: 0 utility.wb-pixel-to-rem(8px);
  display: none;

  &--visible {
    display: inline-flex;
  }
}

.overlay {
  box-shadow: var(--wb-shadow-s);
  position: absolute;
  inset-inline: 0;
  inset-block-start: 100%;
  z-index: 1;
  width: 100%;
  max-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: utility.wb-pixel-to-rem(24px) utility.wb-pixel-to-rem(16px);
  background-color: var(--wb-white);
  opacity: 0;
  transform: translate3d(0, utility.wb-pixel-to-rem(-4px), 0);
  transition:
    opacity $transition-duration var(--wb-fade),
    transform $transition-duration var(--wb-move),
    max-height 0s $transition-duration;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: utility.wb-pixel-to-rem(24px);

  @media (prefers-reduced-motion) {
    transition:
      transform 0s,
      max-height 0s;
  }
}

:host(:not([open])) .overlay {
  pointer-events: none;
  visibility: hidden;
}

:host([open]) {
  .button {
    border-color: var(--focus-color) !important;
  }

  .overlay {
    min-width: max-content;
    white-space: nowrap;
    padding-inline-end: utility.wb-pixel-to-rem(24px);
    height: auto;
    opacity: 1;
    transform: translate3d(0, 0, 0);
    max-height: utility.wb-pixel-to-rem(280px);
    transition:
      opacity $transition-duration var(--wb-fade),
      transform $transition-duration var(--wb-move),
      max-height 0s 0s;

    @media (prefers-reduced-motion) {
      transition:
        transform 0s,
        max-height 0s;
    }
  }

  .caret-icon {
    transform: rotateZ(180deg);
  }
}

:host([theme='dark']) {
  --focus-color: var(--wb-blue-50);

  .button {
    border-color: var(--wb-grey-40);
    background-color: var(--wb-grey-15);
    color: var(--wb-white);
  }

  .close {
    color: var(--wb-white);

    &:hover {
      background-color: var(--wb-grey-20);
    }
  }

  .caret-icon {
    color: var(--wb-white);
  }

  .overlay {
    border: utility.wb-pixel-to-rem(1px) solid var(--wb-grey-40);
    border-block-start-width: 0;
    background-color: var(--wb-black);
  }
}

:host([theme='dark']:not([disabled])) .button:hover {
  background-color: var(--wb-black);
}

:host([disabled]) {
  opacity: 0.6;
  cursor: not-allowed;

  .button {
    pointer-events: none;
  }
}
